import { render, staticRenderFns } from "./UserSettingsPopup.vue?vue&type=template&id=3a3fda88&scoped=true&"
import script from "./UserSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./UserSettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsPopup.vue?vue&type=style&index=0&id=3a3fda88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3fda88",
  null
  
)

export default component.exports